export const TYPES = {
    DANGER: 'danger',
    WARNING: 'warning',
    SUCCESS: 'success',
    PRIMARY: 'primary'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/notification/notification.types.ts